import pkg from '../../../../package.json';

export const environment = {
  production: true,
  env: 'dev',
  version: pkg.version,
  platform: 'webapp',
  baseUrl: 'https://dev-api.esim.management.mobile.glowingbud.xyz',
  paymentMsUrl: 'https://payment-microservice.glowingbud.xyz',
  translateApiUrl: 'https://dev-gb-qrcode-generator.glowingbud.xyz/translate',
  s3BucketUrl: 'https://assets.glowingbud.com',
  universalURL: 'https://esimsetup.apple.com/esim_qrcode_provisioning?carddata=',
  previewMode: false,
  appleSocialAuth: {
    clientId: 'dev.app.whitelabel',
    scope: 'name email',
    redirectURI: 'https://dev-app.glowingbud.xyz/auth/signin',
    usePopup: true,
    state: 'gbsocialsignup',
  },
  googlePayMerchantId: '',
};
